import produce from 'immer';
import { isUndefined } from 'lodash';

import { ComposedActions } from '../../helpers/actions';
import {
    DisplayConstants, ExecutorActions, FieldsMode, MonitorConfig, PolygonTypes, S80ExecutorActions,
    S80Monitors
} from '../../helpers/constants';
import { arrayToObjParams } from '../../helpers/utils';
import { types as executorActions } from '../actions/executor.actions';
import { types as s80Actions } from '../actions/s80_touchpanel.actions';

export const initialState = {
  touchPanelVariables: {
    activeMonitor: 'upper',
    surveil_on_off: 'on',
    trcking_auto_manual: 'auto',
    silence_on_off: 'on',
    apctrl_on_off: 'off',
    osctrl_on_off: 'off',
    msctrl_on_off: 'off',
    losview_on_off: 'off',
    cruise_active_deactiv: 'active',
    ap_btsh_on_off: 'on',
    os_btsh_on_off: 'on',
    ap_gyrb_on_off: 'on',
    os_gyrb_on_off: 'on',
    ap_slnc_on_off: 'on',
    os_slnc_on_off: 'on',
    dangers_on_off: 'on',
    buttonStatus: {
      tas_antenna: {
        isLit: true,
      },
    },
  },
  residentRoles: [],
  activeVabArray: 'Main Array',
  modeSystem: '',
  modeConsole: '',
  monitorLayout: {
    upper: '',
    lower: '',
  },
  playAlertSound: true,

  monitorFieldModes: {
    auxMode: {
      lower: FieldsMode.MOB,
      upper: FieldsMode.MOB,
    },
    spareAreaMode: {
      lower: FieldsMode.PERISCOPE,
      upper: FieldsMode.PERISCOPE,
    },
    showMobIcon: false,
  },
  showRangeInControl: true,
  mfccRoles: {},
  monitorFields: {},
  tutorialArea: {
    show: false,
  },

  tsdTutorialAreaText: '',
  lowerMonitorLeds: {},
  lowerMonitorButtons: {
    GB_bite: false,
    GB_system_halt: false,
    GB_system_reset: false,
    GB_overt_test: false,
    GB_spare: false,
    GB_fire: false,
    GB_stdwn: false,
    GB_cutter: false,
    GB_battle_short: false,
    GB_buzzer_reset: false,
    GB_mute: false,
    safe_key: false,
  },
  lowerMonitorLEDs: {
    GB_fire: false,
    GB_stdwn: false,
    GB_cutter: false,
    GB_battle_short: false,
    GB_buzzer_reset: false,
    GB_mute: false,
  },

  tacsit: {
    showBallTabArea: true,
    showGeneralInfoArea: true,
  },
};

const setTSDTutorialAreaText = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const action = arrayToObjParams(actionPayload);
    draftState.tsdTutorialAreaText = action.message;
  });

const updateTutorialArea = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const action = arrayToObjParams(actionPayload);
    draftState.tutorialArea = {
      ...state.tutorialArea,
      tutorialCode: action.tutorialCode,
      term: action.term,
      def: action.def,
    };
  });

const showTutorialArea = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    draftState.tutorialArea.show = true;
  });

const hideTutorialArea = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    draftState.tutorialArea.show = false;
  });

const updateMonitorFields = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const action = arrayToObjParams(actionPayload);
    const monitorIds = Object.keys(action).filter((id) => id !== 'monitor');
    const newFields: any = {};
    monitorIds.forEach((id) => {
      if (action.monitor === 'both') {
        newFields[`lower_${id}`] = action[id];
        newFields[`upper_${id}`] = action[id];
      } else {
        newFields[`${action.monitor}_${id}`] = action[id];
      }
    });
    // console.log('newFields ',newFields, action)
    draftState.monitorFields = {
      ...state.monitorFields,
      ...newFields,
    };
  });

const contains = (haystack: string, needle: string) =>
  (haystack || '').toLowerCase().indexOf(needle) !== -1;

const setItemToMonitors = (
  monitor: string,
  existingObj: any,
  itemToSet: string
) => {
  if (monitor === 'both') {
    existingObj.lower = itemToSet;
    existingObj.upper = itemToSet;
    return;
  }
  return (existingObj[monitor] = itemToSet);
};

const setAuxAndSpareArea = (draftState: any, type: string, monitor: string) => {
  if (contains(type, 'aux-info') || contains(type, 'auxinfo')) {
    if (contains(type, 'navaid')) {
      setItemToMonitors(
        monitor,
        draftState.monitorFieldModes.auxMode,
        FieldsMode.NAVAID
      );
      // draftState.monitorFieldModes.auxMode = FieldsMode.NAVAID;
    } else if (contains(type, 'mob')) {
      setItemToMonitors(
        monitor,
        draftState.monitorFieldModes.auxMode,
        FieldsMode.MOB
      );
      // draftState.monitorFieldModes.auxMode = FieldsMode.MOB;
    } else if (contains(type, 'periscope')) {
      setItemToMonitors(
        monitor,
        draftState.monitorFieldModes.auxMode,
        FieldsMode.PERISCOPE
      );
      // draftState.monitorFieldModes.auxMode = FieldsMode.PERISCOPE;
    }
  } else if (contains(type, 'spare-area') || contains(type, 'sparearea')) {
    if (contains(type, 'radar-link') || contains(type, 'radarlink')) {
      setItemToMonitors(
        monitor,
        draftState.monitorFieldModes.spareAreaMode,
        FieldsMode.RADAR_LINK
      );
      // draftState.monitorFieldModes.spareAreaMode = FieldsMode.RADAR_LINK;
    } else if (contains(type, 'periscope')) {
      setItemToMonitors(
        monitor,
        draftState.monitorFieldModes.spareAreaMode,
        FieldsMode.PERISCOPE
      );
      //  draftState.monitorFieldModes.spareAreaMode = FieldsMode.PERISCOPE;
    }
  }
};

const updateMonitorFieldModes = (state: any, type: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    setAuxAndSpareArea(draftState, type, actionPayload.monitor);
  });

const updateTouchPanelVariable = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { key, value } = payload;
    draftState.touchPanelVariables = {
      ...state.touchPanelVariables,
      [key]: value,
    };
  });

const updateMonitorLayout = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const action = arrayToObjParams(actionPayload);
    draftState.monitorLayout = {
      ...state.monitorLayout,
      [action.monitor]: action.layoutMode,
    };
  });

const updateMOBIcon = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    draftState.monitorFieldModes.showMobIcon = payload;
  });

const updateDisableEnableStatus = (
  state: any,
  payload: any,
  changedProps: any
) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const action = arrayToObjParams(actionPayload);
    const existingData =
      state.touchPanelVariables.buttonStatus[
        action.TouchPanelButtonClickedId
      ] || {};
    draftState.touchPanelVariables.buttonStatus = {
      ...state.touchPanelVariables.buttonStatus,
      [action.TouchPanelButtonClickedId]: {
        ...existingData,
        ...changedProps,
      },
    };
  });

const updateIsLitStatus = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { broadcasted, ...restProps } = payload;
    const existingData = Object.keys(restProps).reduce(
      (curr: any, key: string) => {
        const input = restProps[key];
        let prop: any = input;
        if (input.isLit === 'toggle') {
          prop = {
            isLit: !(
              state?.touchPanelVariables?.buttonStatus[key] &&
              state.touchPanelVariables.buttonStatus[key].isLit
            ),
          };
        }
        curr[key] = {
          ...state.touchPanelVariables.buttonStatus[key],
          ...prop,
        };
        return curr;
      },
      {}
    );

    draftState.touchPanelVariables.buttonStatus = {
      ...state.touchPanelVariables.buttonStatus,
      ...existingData,
    };
  });

const updateIsBlinkingtatus = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { broadcasted, ...restProps } = payload;
    const existingData = Object.keys(restProps).reduce(
      (curr: any, key: string) => {
        const input = restProps[key];
        let prop: any = input;
        if (input.isBlinking === 'toggle') {
          prop = {
            isBlinking: !(
              state?.touchPanelVariables?.buttonStatus[key] &&
              state.touchPanelVariables.buttonStatus[key].isBlinking
            ),
          };
        }
        curr[key] = {
          ...state.touchPanelVariables.buttonStatus[key],
          ...prop,
        };
        return curr;
      },
      {}
    );

    draftState.touchPanelVariables.buttonStatus = {
      ...state.touchPanelVariables.buttonStatus,
      ...existingData,
    };
  });

const updateMfccRoles = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const action = arrayToObjParams(actionPayload);
    draftState.mfccRoles = {
      mfccOne: action.mfccOne,
      mfccTwo: action.mfccTwo,
      mfccThree: action.mfccThree,
      mfccFour: action.mfccFour,
      mfccFive: action.mfccFive,
      mfccSix: action.mfccSix,
      mfccSeven: action.mfccSeven,
    };
  });

const updateActiveMonitor = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const action = arrayToObjParams(actionPayload);
    console.log('active monitor', action);
    draftState.touchPanelVariables.activeMonitor = action.monitor;
  });

const updateResidentRoles = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const action = arrayToObjParams(actionPayload);
    draftState.residentRoles = [...state.residentRoles, action.role];
  });

const updateGeneralInformationArea = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const action = arrayToObjParams(actionPayload);
    draftState.modeSystem = action.modeSystem;
    draftState.modeConsole = action.modeConsole;
  });

const updateActiveVabArray = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { vabArrayValue } = payload;
    draftState.activeVabArray = (vabArrayValue || '').replace(/#\//, '');
  });

const removeResidentRole = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const action = arrayToObjParams(actionPayload);
    draftState.residentRoles = state.residentRoles.filter(
      (residentRole: any) => residentRole === action.role
    );
  });

const removeAllResidentRoles = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    draftState.residentRoles = [];
  });

const systemUpdateTouchPanelVariable = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const action = arrayToObjParams(actionPayload);
    const { TouchPanelToggleButtonId, TouchPanelToggleButtonValue } = action;
    draftState.touchPanelVariables = {
      ...state.touchPanelVariables,
      [TouchPanelToggleButtonId]: TouchPanelToggleButtonValue,
    };
  });

const getMonitorVariable = (layout: string) => {
  switch (layout) {
    case 'tactico':
      return MonitorConfig.TACTICO;
    case 'sonar':
      return MonitorConfig.SONAR;
    case 'link':
      return MonitorConfig.LINK;
    case 'sistema':
      return MonitorConfig.SISTEMA;
    case 'weapon':
      return MonitorConfig.WEAPON;
    case 'obt':
      return MonitorConfig.OBT;
    case 'wpu':
      return MonitorConfig.WPU;
  }
};

const getMonitor = (layout) => {
  if (layout.both) return 'both';
  if (layout.lower) return 'lower';
  return 'upper';
};

const updateMonitorConfiguration = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { monitorLayout } = payload;
    const { layout, ...rest } = monitorLayout;
    draftState.monitorLayout = {
      upper: getMonitorVariable(layout),
      lower: getMonitorVariable(layout),
    };
    const newFields: any = {};

    Object.keys(rest).map((layoutName) => {
      const layout = rest[layoutName];
      if (layout.both) {
        layout.both.map((layoutConfiguration: any) => {
          const { id, ...params } = layoutConfiguration;
          newFields[`lower_${id}`] = params;
          newFields[`upper_${id}`] = params;
        });
      }
      if (layout.upper) {
        layout.upper.map((layoutConfiguration: any) => {
          const { id, ...params } = layoutConfiguration;
          newFields[`upper_${id}`] = params;
        });
      }
      if (layout.lower) {
        layout.lower.map((layoutConfiguration: any) => {
          const { id, ...params } = layoutConfiguration;
          newFields[`lower_${id}`] = params;
        });
      }
      const monitor = getMonitor(layout);
      setAuxAndSpareArea(draftState, layoutName, monitor);
    });
    draftState.monitorFields = {
      ...newFields,
    };
  });

const updateLowerMonitorLeds = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const { id, ledIndicator } = arrayToObjParams(actionPayload);
    draftState.lowerMonitorLeds[id] = ledIndicator;
  });

const updateGeneralButtonStatus = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { id, isActive } = payload;
    draftState.lowerMonitorButtons[id] = isActive;
    if (id === 'RAP_sound_off_button') {
      draftState.playAlertSound = !state.playAlertSound;
    }
  });

const updateBallTabAreaShowStatus = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    draftState.tacsit.showGeneralInfoArea = payload.show;
  });

const updateGeneralInfoAreaShowStatus = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    draftState.tacsit.showBallTabArea = payload.show;
  });

const updateGeneralButtonLED = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { actionPayload } = payload;
    const actionObj = arrayToObjParams(actionPayload);
    const { id, isActive } = actionObj;
    draftState.lowerMonitorLEDs[id] = isActive;
  });

const updateRangeInVisibility = (state: any, show: boolean) =>
  produce(state, (draftState: any) => {
    draftState.showRangeInControl = show;
  });

const reducer = (state = initialState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case executorActions.RESET_EXECUTOR_STATE:
      return initialState;

    case ComposedActions.SystemSetGeneralButtonLED.id:
      return updateGeneralButtonLED(state, payload);

    case ComposedActions.SystemHideTacsitRangeInOut.id:
      return updateRangeInVisibility(state, false);
    case ComposedActions.SystemShowTacsitRangeInOut.id:
      return updateRangeInVisibility(state, true);

    case S80ExecutorActions.SetActiveMonitor:
      return updateActiveMonitor(state, payload);
    case S80ExecutorActions.SetMFCCRoles:
      return updateMfccRoles(state, payload);
    case S80ExecutorActions.SystemShowMob:
      return updateMOBIcon(state, true);
    case S80ExecutorActions.SystemHideMob:
      return updateMOBIcon(state, false);
    case ComposedActions.SystemDisableTouchPanelButton.id:
      return updateDisableEnableStatus(state, payload, { isDisabled: true });
    case ComposedActions.SystemEnableTouchPanelButton.id:
      return updateDisableEnableStatus(state, payload, { isDisabled: false });
    case executorActions.UPDATE_TSD_ILLUMINATION:
      return updateIsLitStatus(state, payload);
    case executorActions.UPDATE_TSD_BLINKING:
      return updateIsBlinkingtatus(state, payload);
    case S80ExecutorActions.SetMonitorLayout:
      return updateMonitorLayout(state, payload);
    case S80ExecutorActions.SignOnRole:
      return updateResidentRoles(state, payload);
    case S80ExecutorActions.SignOffRole:
      return removeResidentRole(state, payload);
    case S80ExecutorActions.SignOffAllRoles:
      return removeAllResidentRoles(state, payload);

    case S80ExecutorActions.SystemSetTouchPanelToggleVariable:
      return systemUpdateTouchPanelVariable(state, payload);
    case S80ExecutorActions.ShowTSDGeneralInformationArea:
      return updateGeneralInformationArea(state, payload);
    case s80Actions.SET_ACTIVE_VABARRAY:
      return updateActiveVabArray(state, payload);
    case executorActions.TOGGLE_BUTTON_CLICK:
      return updateTouchPanelVariable(state, payload);
    case executorActions.INTERNAL_SET_MONITORLAYOUT_CONFIG:
      return updateMonitorConfiguration(state, payload);
    case ComposedActions.ShowTutorialInTutorialArea.id:
      return updateTutorialArea(state, payload);
    case S80ExecutorActions.SystemShowTutorialArea:
      return showTutorialArea(state, payload);
    case S80ExecutorActions.SystemHideTutorialArea:
      return hideTutorialArea(state, payload);
    case ComposedActions.ShowTextInTsdTutorialArea.id:
      return setTSDTutorialAreaText(state, payload);
    case S80ExecutorActions.SystemSetSonarWorkModeArea:
    case S80ExecutorActions.SystemSetSonarCursorInfoArea:
    case S80ExecutorActions.SystemSetSonarShipInfoArea:
    case S80ExecutorActions.SystemSetSonarAudioInfoArea:
    case S80ExecutorActions.SystemSetSonarAuxInfoArea:
    case S80ExecutorActions.SystemSetSonarCSRAInfoArea:
    case S80ExecutorActions.SystemSetTacticalCSRAInfoArea:
    case S80ExecutorActions.SystemSetSystemLayoutCSRAInfoArea:
    case S80ExecutorActions.SystemSetSystemLayoutShipInfoArea:
    case S80ExecutorActions.SystemSetWeaponCSRAInfoArea:
    case S80ExecutorActions.SystemSetObtShipInfoArea:
    case S80ExecutorActions.SystemSetLinkLayoutCSRAInfoArea:
    case S80ExecutorActions.SystemSetLinkLayoutLinkStatusArea:
    case S80ExecutorActions.SystemSetTacticalShipInfoArea:
    case S80ExecutorActions.SystemSetRoleInfoArea:
      return updateMonitorFields(state, payload);
    case S80ExecutorActions.SystemSetTacticalAuxInfoAreaNavaid:
    case S80ExecutorActions.SystemSetTacticalAuxInfoAreaMob:
    case S80ExecutorActions.SystemSetTacticalAuxInfoAreaPeriscope:
    case S80ExecutorActions.SystemSetTacticalSpareAreaPeriscope:
    case S80ExecutorActions.SystemSetTacticalSpareAreaRadarLink:
    case S80ExecutorActions.SystemSetWeaponShipInfoArea:
      return updateMonitorFields(
        updateMonitorFieldModes(state, type, payload),
        payload
      );
    case S80ExecutorActions.SystemSetLowerMonitorLED:
      return updateLowerMonitorLeds(state, payload);
    case executorActions.UPDATE_GENERAL_BUTTON_STATUS:
    case ComposedActions.PressGeneralButtonSwitch.uiAction:
      return updateGeneralButtonStatus(state, payload);
    case S80ExecutorActions.SystemHideTacsitGeneralInfoArea:
      return updateGeneralInfoAreaShowStatus(state, { show: false });
    case S80ExecutorActions.SystemShowTacsitGeneralInfoArea:
      return updateGeneralInfoAreaShowStatus(state, { show: true });
    case S80ExecutorActions.SystemHideTacsitBallTabPosition:
      return updateBallTabAreaShowStatus(state, { show: false });
    case S80ExecutorActions.SystemShowTacsitBallTabPosition:
      return updateBallTabAreaShowStatus(state, { show: true });
    default:
      return state;
  }
};

export default reducer;
